import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoginDetailsState {
  userRole: string;
  emailId: string;
}

const initialState: LoginDetailsState = {
  userRole: "",
  emailId: "",
};

const loginDetailsSlice = createSlice({
  name: "loginDetails",
  initialState,
  reducers: {
    setUserRole(state, action: PayloadAction<{ role: string; email: string }>) {
      state.userRole = action.payload.role;
      state.emailId = action.payload.email;
    },
  },
});

export const { setUserRole } = loginDetailsSlice.actions;

export default loginDetailsSlice.reducer;

export const selectUserRole = (state: { loginDetails: LoginDetailsState }) =>
  state.loginDetails.userRole;

export const selectUserEmail = (state: { loginDetails: LoginDetailsState }) =>
  state.loginDetails.emailId;
